import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingCards() {
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" id="pricing" data-id="element-266">
      <FadeIn data-id="element-267">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-6 md:mb-12 tracking-tight" data-id="element-268">
          ELEGÍ TU MEGAPACK
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 max-w-4xl mx-auto items-center" data-id="element-269">
        {/* Card 1 */}
        <FadeIn delay={0.1} data-id="element-270">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl md:rounded-3xl p-5 md:p-10 h-full flex flex-col relative hover:border-gray-600 transition-colors" data-id="element-271">
            <div className="mb-4 md:mb-6" data-id="element-272">
              <h3 className="text-lg md:text-xl font-black text-white flex items-center gap-2 mb-1 md:mb-2" data-id="element-273">
                <span className="text-xl md:text-2xl" data-id="element-274">📘</span> MEGAPACK BÁSICO
              </h3>
              <p className="text-gray-400 font-medium text-xs md:text-sm" data-id="element-275">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-4 md:mb-8 pb-4 md:pb-8 border-b border-gray-800" data-id="element-276">
              <div className="text-red-400 line-through text-sm md:text-lg font-medium mb-0.5 md:mb-1" data-id="element-277">
                $95.000
              </div>
              <div className="text-3xl md:text-4xl font-black text-white flex items-baseline gap-2" data-id="element-278">
                $19.990{' '}
                <span className="text-base md:text-lg text-gray-400 font-medium" data-id="element-279">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-2.5 md:space-y-4 mb-5 md:mb-10 flex-grow" data-id="element-280">
              <li className="flex items-start gap-3" data-id="element-281">
                <div className="bg-green-500/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-282">
                  <Check className="text-green-500" size={16} strokeWidth={3} data-id="element-283" />
                </div>
                <span className="text-sm md:text-base text-gray-300 font-medium" data-id="element-284">
                  Acceso a los 6 Tomos completos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-285">
                <div className="bg-green-500/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-286">
                  <Check className="text-green-500" size={16} strokeWidth={3} data-id="element-287" />
                </div>
                <span className="text-sm md:text-base text-gray-300 font-medium" data-id="element-288">
                  Los 6 Bonos de regalo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-289">
                <div className="bg-green-500/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-290">
                  <Check className="text-green-500" size={16} strokeWidth={3} data-id="element-291" />
                </div>
                <span className="text-sm md:text-base text-gray-300 font-medium" data-id="element-292">
                  Actualizaciones de por vida
                </span>
              </li>
            </ul>

            <a href="https://www.tumanualdigital.com/cart/44024762368036:1" className="w-full block text-center py-3 md:py-4 px-4 md:px-6 rounded-xl font-black text-base md:text-lg bg-gray-800 hover:bg-gray-700 text-white transition-colors border border-gray-700" data-id="element-293">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </FadeIn>

        {/* Card 2 - Featured */}
        <FadeIn delay={0.2} data-id="element-294">
          <div className="relative" data-id="element-295">
            <div className="absolute inset-0 bg-green-500/20 blur-3xl rounded-[3rem] animate-pulse" data-id="element-296"></div>
            <div className="bg-gradient-to-b from-gray-900 to-black border-2 border-green-500 rounded-2xl md:rounded-[2.5rem] p-5 md:p-12 h-full flex flex-col relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(34,197,94,0.2)] z-10" data-id="element-297">
              <div className="absolute -top-4 md:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-green-400 to-green-600 text-black font-black px-4 md:px-6 py-1.5 md:py-2 rounded-full text-xs md:text-sm flex items-center gap-1.5 md:gap-2 whitespace-nowrap shadow-lg" data-id="element-298">
                <Star className="w-3.5 h-3.5 md:w-4 md:h-4" fill="currentColor" data-id="element-299" />{' '}
                MÁS ELEGIDO
              </div>

              <div className="mb-4 md:mb-6 mt-3 md:mt-4" data-id="element-300">
                <h3 className="text-lg md:text-2xl font-black text-white flex items-center gap-2 mb-1 md:mb-2" data-id="element-301">
                  <span className="text-2xl md:text-3xl" data-id="element-302">🏆</span> MEGAPACK +
                  CEREBRO
                </h3>
                <p className="text-green-400 font-bold text-xs md:text-sm" data-id="element-303">
                  6 Tomos + 6 Bonos + Sistema de Organización
                </p>
              </div>

              <div className="mb-4 md:mb-8 pb-4 md:pb-8 border-b border-gray-800" data-id="element-304">
                <div className="text-red-400 line-through text-sm md:text-lg font-medium mb-0.5 md:mb-1" data-id="element-305">
                  $130.000
                </div>
                <div className="text-3xl md:text-5xl font-black text-white flex items-baseline gap-2" data-id="element-306">
                  $27.990{' '}
                  <span className="text-base md:text-xl text-gray-400 font-medium" data-id="element-307">
                    ARS
                  </span>
                </div>
              </div>

              <ul className="space-y-3 md:space-y-5 mb-5 md:mb-10 flex-grow" data-id="element-308">
                <li className="flex items-start gap-3" data-id="element-309">
                  <div className="bg-green-500/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-310">
                    <Check className="text-green-500" size={18} strokeWidth={3} data-id="element-311" />
                  </div>
                  <span className="text-sm md:text-base text-gray-200 font-bold" data-id="element-312">
                    Todo lo del Megapack Básico
                  </span>
                </li>
                <li className="flex items-start gap-3 bg-green-900/30 p-2.5 md:p-3 rounded-xl border border-green-500/30 -mx-2 md:-mx-3" data-id="element-313">
                  <div className="bg-green-500 p-1 rounded-full shrink-0 mt-0.5" data-id="element-314">
                    <Check className="text-black" size={18} strokeWidth={4} data-id="element-315" />
                  </div>
                  <span className="text-sm md:text-base text-green-300 font-black" data-id="element-316">
                    Sistema Cerebro Digital (7 módulos)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-317">
                  <div className="bg-green-500/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-318">
                    <Check className="text-green-500" size={18} strokeWidth={3} data-id="element-319" />
                  </div>
                  <span className="text-sm md:text-base text-gray-300 font-medium" data-id="element-320">
                    Plantillas de Drive automatizadas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-321">
                  <div className="bg-green-500/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-322">
                    <Check className="text-green-500" size={18} strokeWidth={3} data-id="element-323" />
                  </div>
                  <span className="text-sm md:text-base text-gray-300 font-medium" data-id="element-324">
                    Scripts de WhatsApp Business
                  </span>
                </li>
              </ul>

              <motion.a whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} href="https://www.tumanualdigital.com/cart/44024763645988:1" className="w-full block text-center py-3.5 md:py-5 px-4 md:px-6 rounded-xl font-black text-base md:text-lg bg-green-500 hover:bg-green-400 text-black transition-colors shadow-[0_0_20px_rgba(34,197,94,0.4)]" data-id="element-325">
                → QUIERO EL MEGAPACK + CEREBRO
              </motion.a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}